import * as React from 'react';
import { useDispatch } from 'react-redux';
import { REMOVE_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER, SET_CART_LOADER_DATA_OBJECT } from 'src/store/slice/model/Cart';
import CartRepository from "../../../repository/CartRepository";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const ClearSingleCartProductFromCart = (props) => {
    const dispatch = useDispatch();
    const { currentCartItem } = props;
    const ClearSingleCartProductFromCart = () => {
        new CartRepository().clearSingleCartProductFromFromServerByCartDetailId(currentCartItem.cartDetailId);

        /**
         * 9369 - DT - 20 March - My Cart: Manually add option is showing default selected with entered cpn on re-adding the same part in the cart once deleted the part
         * Change #  : When Item is remove from the Cart It will remove from the CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER.
         */

        dispatch(
            REMOVE_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER({
                CART_DATA: currentCartItem,
            })
        );

        dispatch(SET_CART_LOADER_DATA_OBJECT({}))
        clearSingleCartEvent();
    };

     //By Ramya Kannan [Clear single cart - Adobe script ]
  function clearSingleCartEvent(){
    localStorage.setItem("adobeEventType","cartRemovalEvent");
    let prodDetails = currentCartItem;
    if(Object.keys(prodDetails).length){
        HelperAdobeEvent.trackingAdobeEvent({prodDetails});

    }
}
    return (
        <React.Fragment>
            <div onClick={() => {
                ClearSingleCartProductFromCart();
            }}>
                {props.children}
            </div>
        </React.Fragment>
    );
};

export default ClearSingleCartProductFromCart;